import {MODULE_DISTRIBUTION_SERVICES} from '../services/app.services.module';
import AbbraviatedTextComponent from './jf-abbraviated-text/abbraviated.text.component';
import AttributesComponent from './jf-attributes/jf-attributes.component';
import JfBintrayKonami from './jf-bintray-konami/jf_bintray_konami';
import CancelBackButton from './jf-cancel-back-button/jf-cancel-back-button.component';
import PageTitleComponent from './jf-page-title/page.title.component';
import PageTitleIconComponent from './jf-page-title/page.title.icon.component';
import ReadOnlyTableComponent from './jf-read-only-table/jf.read.only.table.component';
import ReleaseNotesComponent from './jf-release-notes/jf-release-notes.component';
import ServerValidatedFormDirective from './jf-server-validated-form/jf-server-validated-form.component';
import jfMessages from './jf_messages/jf_messages';
import BreadcrumbsComponent from './jf-breadcrumbs/jf.breadcrumbs.component';
import ActionButtonsComponent from '../directives/jf-action-buttons/action.buttons.component';
import {MODULE_DISTRIBUTION_DAO} from "../data/app_dao_module";

export const MODULE_DISTRIBUTION_DIRECTIVES = 'distribution.directives';

angular.module(MODULE_DISTRIBUTION_DIRECTIVES, [
    'uiCropper',
    MODULE_DISTRIBUTION_SERVICES,  // TODO: import missing services
    MODULE_DISTRIBUTION_DAO, // TODO: replace this with 'MODULE_DISTRIBUTION_DAO' / merge into RT
    'ui.select',
    'ngSanitize',
    'ui.highlight'
]);

angular.register(MODULE_DISTRIBUTION_DIRECTIVES)
       .directives([
	       JfBintrayKonami,
	       jfMessages,
	       ServerValidatedFormDirective
       ])
       .components([
	       AbbraviatedTextComponent,
	       PageTitleComponent,
	       PageTitleIconComponent,
	       AttributesComponent,
	       ReleaseNotesComponent,
	       BreadcrumbsComponent,
	       ActionButtonsComponent,
	       CancelBackButton,
	       ReadOnlyTableComponent
       ]);



// WEBPACK FOOTER //
// ./modules/distribution/directives/app.directives.module.js